/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChallengeStatusResponse } from '../models/ChallengeStatusResponse';
import type { ResendPushChallengeResponse } from '../models/ResendPushChallengeResponse';
import type { StoredMobilePushPayload } from '../models/StoredMobilePushPayload';
import type { ValidatePushChallengeRequest } from '../models/ValidatePushChallengeRequest';
import type { ValidatePushChallengeResponse } from '../models/ValidatePushChallengeResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MfaPushService {
    /**
     * Get MFA Status
     * Get current MFA challenge status
     * @param mfaSession
     * @returns ChallengeStatusResponse Successful Response
     * @throws ApiError
     */
    public static getMfaStatus(
        mfaSession?: (string | null),
    ): CancelablePromise<ChallengeStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mfa/status',
            cookies: {
                'mfa_session': mfaSession,
            },
            errors: {
                400: `Flow has no alternative method, session has no active step, or factor type unsupported for the requested action`,
                401: `MFA session expired / flow not found`,
                403: `Submit/choose rejected by orchestrator`,
                422: `Validation Error`,
                426: `Client app version is below the minimum supported version`,
            },
        });
    }
    /**
     * Validate Push Challenge
     * Validate push notification challenge
     * @param requestBody
     * @returns ValidatePushChallengeResponse Successful Response
     * @throws ApiError
     */
    public static validatePushChallengePublic(
        requestBody: ValidatePushChallengeRequest,
    ): CancelablePromise<ValidatePushChallengeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mfa/push/validate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Push challenge cannot be validated in its current state`,
                422: `Validation Error`,
                426: `Client app version is below the minimum supported version`,
            },
        });
    }
    /**
     * Resend Push Challenge
     * Resend push notification challenge
     * @param mfaSession
     * @returns ResendPushChallengeResponse Successful Response
     * @throws ApiError
     */
    public static resendPushChallengePublic(
        mfaSession?: (string | null),
    ): CancelablePromise<ResendPushChallengeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mfa/push/resend',
            cookies: {
                'mfa_session': mfaSession,
            },
            errors: {
                400: `Flow has no alternative method, session has no active step, or factor type unsupported for the requested action`,
                401: `MFA session expired / flow not found`,
                403: `Submit/choose rejected by orchestrator`,
                422: `Validation Error`,
                426: `Client app version is below the minimum supported version`,
            },
        });
    }
    /**
     * Recover the stored MFA push payload for a notification tag
     * Recover the push payload the OS dropped, then delete it (single-use).
     * @param tag
     * @param xPushToken
     * @returns StoredMobilePushPayload Successful Response
     * @throws ApiError
     */
    public static getPushPayload(
        tag: string,
        xPushToken: string,
    ): CancelablePromise<StoredMobilePushPayload> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mfa/push/payload/{tag}',
            path: {
                'tag': tag,
            },
            headers: {
                'x-push-token': xPushToken,
            },
            errors: {
                404: `Push payload not found or already consumed`,
                422: `Validation Error`,
            },
        });
    }
}
